const contactUs = {
  formTitle: 'Contact us',
  submit: 'Send',
  mail: 'Email',
  name: 'Name',
  comment: 'Message',
  sendText: 'Thanks for contacting us!',
  toForm: 'Back'
}
export default contactUs;